import { SchedulerModel } from '../model/scheduler-model';
import { ScheduleEntity } from '../apis/schedule/schedule-entity';
import { SerieSettingEntity } from '../apis/serie/serie-setting-entity';
import { inject } from 'aurelia';
import { v1 as uuidv1 } from 'uuid';
import { ProjectModelService } from './project-model-service';

@inject(ProjectModelService)
export class SchedulerModelService {

    private _modelCache: SchedulerModel = null;
    private _projectModelService: ProjectModelService;

    constructor(projectModelService: ProjectModelService) {
        this._projectModelService = projectModelService;
    }

    public get isLoaded(): boolean {
        return this._modelCache !== null;
    }

    public get model(): SchedulerModel {
        return this._modelCache;
    }

    public setModelCache(model: SchedulerModel): void {
        this._modelCache = model;
    }

    // Builds a SchedulerModel from the ProjectModelService cache. Synchronous — no API calls.
    public loadByScheduleId(scheduleId: string): SchedulerModel {
        if (this._modelCache != null && this._modelCache.scheduleId === scheduleId) {
            return this._modelCache;
        }
        const model = this._projectModelService.currentModel;
        const schedule = model.schedules.find(s => s.id === scheduleId);
        const teams = this._projectModelService.getTeamsForGroups(schedule?.groupIds ?? []);
        const serie = this._projectModelService.getSerieForSchedule(scheduleId);
        const customIntervals = this._projectModelService.getCustomIntervalsForSchedule(scheduleId);
        const games = this._projectModelService.getGamesForSchedule(scheduleId);
        this._modelCache = new SchedulerModel(schedule, serie, teams, customIntervals, games);
        return this._modelCache;
    }

    // Creates an empty SchedulerModel for a new schedule. Synchronous — no API calls.
    public createNew(eventId: string): SchedulerModel {
        const schedule = new ScheduleEntity();
        schedule.id = uuidv1();
        schedule.eventId = eventId;
        schedule.sortOrder = this._projectModelService.getNextScheduleSortOrder();
        this._modelCache = new SchedulerModel(schedule, new SerieSettingEntity(), [], [], []);
        return this._modelCache;
    }
}

